export default {
  getAssociationProvider: state => state.association.provider,
  getAssociationScheme: state => state.association.scheme,
  getPensionSchemes: state => state.association.children,
  getProviderUpdatedData: state => state.association.providerUpdatedData,
  getSchemeUpdatedData: state => state.association.schemeUpdatedData
};
